<template>
    <Breadcrumb page-title="Server Process Management" page-section=""> </Breadcrumb>
   <section class="content">
    <div class="row">
        <div class="col-md-12">
            <!-- Custom Tabs -->
            <div class="row">
                <div class="col-md-12">
                    <div class="box box-info">
                        <div class="box-header with-border">
                            <i class="fa fa-tasks"></i>
                            <h3 class="box-title text-right">AI Embeddings</h3>
                        </div>
                        <div class="box-body">
                            <div class="row">
                            <div class="col-md-12">
                                <p>Any stale AI embeddings are recomputed every minute.</p>
                               <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th class="col-md-1"><label class="control-label text-left">Status</label></th>
                                        <th class="col-md-2"><label class="control-label text-left">Tenant</label></th>
                                        <th class="col-md-3"><label class="control-label text-left">Last Process Time</label></th>
                                        <th class="col-md-2"><label class="control-label text-left">Total Computed</label></th>
                                        <th class="col-md-4"><label class="control-label text-left">Message</label></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                           <Toggle/>
                                        </td>
                                        <td class="text-capitalize"><strong>1to1service</strong></td>
                                        <td><span style="cursor: pointer;" title="2026-02-25 6:57:06 PM">27 seconds ago</span></td>
                                        <td><span style="cursor: pointer;" title="Since 2026-02-25 12:30:05 PM">0</span></td>
                                        <td>Embeddings computed: 0</td>
                                    </tr>
                                </tbody>
                                </table>

                                </div>
                            </div>
                        </div>
                    </div>
                </div> <!-- ✅ closed col-md-12 (missing earlier) -->

                <div class="col-md-4">
                </div>
            </div>
        </div>
        <!-- /.col -->
    </div>
</section>
  </template>
  <style src="@vueform/toggle/themes/default.css"></style>
  <script>
  import Breadcrumb from '../components/Breadcrumb.vue';
  import MyInboxMessages from '../components/MyInboxMessages.vue';
  import InboxMessageDetail from '../components/InboxMessageDetail.vue';
  import iServiceSwitch from '../components/iServiceSwitch.vue';
  import ChatPanelSettings from '../components/ChatPanelSettings.vue';
  import Toggle from '@vueform/toggle'

  import Multiselect from '@vueform/multiselect'
  import Vue from 'vue';
  import { reactive,ref, onMounted } from 'vue'
  export default {
    name: 'MyMessageInboxComponents',
     components: {
      Breadcrumb,
      MyInboxMessages,
      InboxMessageDetail,
      iServiceSwitch,
      Multiselect,
      ChatPanelSettings,
      Toggle
    },
    data:function(){
      return{
        optionparameter : [1],
          searchlength : 1,
      }},
      methods: {
  addValue() {
      this.optionparameter.push('')
      this.searchlength = parseInt(this.searchlength) + 1;
   },
   removeValue(index) {
      if(this.optionparameter.length > 1){
       this.optionparameter.splice(index, 1);
       this.searchlength = parseInt(this.searchlength) - 1;
      }
    }
      },
    setup(){      
         
         var showDetails = reactive({showNew:false,deleteChat:false, showChatDetails:false,currentRow:''});
         var showNew =   reactive(false);
         var deleteChat =  reactive(false);
         var show = reactive(false);
         var currentRow = '';
  
         function showNewChat(){
           showDetails.showNew = true; 
           showDetails.deleteChat = false;  
           showDetails.showChatDetails = false;
           showDetails.active_el = '';
         }
         function showDeleteChat(){
           showDetails.showNew = false; 
           showDetails.deleteChat = true;  
         }
         function showMessageDetails(val,row){
           showDetails.showNew = false; 
           showDetails.deleteChat = false;  
           showDetails.showChatDetails=true;
           showDetails.active_el = row;
         }
         function cancel(){
           showDetails.showNew = false; 
           showDetails.deleteChat = false;  
           showDetails.showChatDetails=false;
         }
         
  
         return{cancel,showNew,deleteChat,showDetails,showNewChat,showDeleteChat,showMessageDetails};
    }
  
  }
  </script>
  